<template>
  <div class="info">
    <div class="mainbg">
      <sec-carousel></sec-carousel>
    </div>
    <div class="mainbgTwo"><img src="../assets/images/news/mainbgTwo.jpg" alt=""></div>
    <div class="container">
        <div class="row rowwarp">
            <div class="rowwpLeft">
                <div class="navList">
                    <div class="navtop">
                        <img src="../assets/images/news/sidebar_title.jpg" alt="">
                        <div class="nav-mes1">{{firMenu.Memo}}</div>
                        <div class="nav-mes2">{{firMenu.Name}}</div>
                    </div>
                    <div class="tab">
                        <div class="btnTab">
                            <span v-for="(items,index) in aboutUs" :key="index" :class="items.Name == curMenu.Name ?'active spanList':'spanList'" @click="getBtn(items)">{{items.Name}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="rowwpRight">
                <div class="itemtop">
                    <img src="../assets/images/news/brnav_home.png" alt="">
                    <span><a href="javascript:void(0);" @click="returnBack">   首页</a></span>
                    <span>&gt;</span>
                    <span><a href="javascript:void(0);">{{fname}}</a></span>
                    <span>&gt;</span>
                    <span><a href="javascript:void(0);">{{name}}</a></span>
                </div>
                <div class="rowwpLeft2">
                    <div class="navList2">
                        <div class="navtop2">
                            <img src="../assets/images/news/sidebar_titleTwo.jpg" alt="">
                            <div class="nav-mes2">{{fname}}</div>
                        </div>
                        <div class="tab2">
                            <div class="tab2Img">
                                <img src="../assets/images/news/rowleft.png"/>
                            </div>
                            <ul class="btnTabTwo">
                                <li v-for="(items,index) in aboutUs" :key="index" :class="items.Name == curMenu.Name ?'activeTwo spanListTwo':'spanListTwo'" @click="getBtn(items)" >{{items.Name}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="box" v-loading="loading">
                  <div class="content html-wrap" v-html="htmlCont" ></div>
                  <bd-map v-if="this.$route.params.key ==='contact'"></bd-map>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as utils from '../utils.js'
import * as api from '../api/api.js'
import SecCarousel from './secCarousel'
import bdMap from './baiduMap'
export default {
  components: {
    SecCarousel,
    bdMap
  },
  data () {
    return {
      name: '',
      fname: '',
      aboutUs: [],
      curMenu: '',
      firMenu: '',
      htmlCont: '',
      loading: false
    }
  },
  watch: {
    '$route': function (val) {
      this.init()
    }
  },
  created () {
	  console.log(this.$route.params.key)
    this.init ()
  },
  methods: {
    // 返回首页
    returnBack(){
      this.$router.push({path: '/'})
    },
    init: function () {
      var storage = utils.storage.get('jinLin_menu')
      if (storage && storage.data) {
        storage.data.forEach((vv) => {
          if (vv.Key === this.$route.params.fkey) {
            this.fname = vv.Name
            var _this = this
            this.aboutUs = vv.subMenu
            this.firMenu = vv
            vv.subMenu.forEach((ss) => {
              if (ss.Key === this.$route.params.key) {
                _this.name = ss.Name
                _this.curMenu = ss
              }
            })
          }
        })
      }
      this.getContent()
    },
    getContent: function () {
      let param = {
        igid: this.curMenu.Id,
        key: this.curMenu.Key + '_cont'
      }
      this.loading = true
      this.htmlCont = ''
      api.getContent(param).then((res) => {
        this.loading = false
        if (res.Status === 100) {
          if(res.Data ==='' || res.Data === undefined || res.Data ===null){
            this.htmlCont='暂无数据'
          }else {
            let curHtml = JSON.parse(res.Data.Value).curHtml
            curHtml = curHtml.replace(/src=\"static\/js\/plugins\/bdmap\/bd.html/g, 'src="http://' + window.location.host + '/static/js/plugins/bdmap/bd.html')
            curHtml = curHtml.replace(/36.156.158.238:23456/g, api.host)
            curHtml = curHtml.replace(/{jinlinhost}/g, api.host)
            if (this.curMenu.Key === 'orge') {
              curHtml = curHtml.replace(/href\=\".*?\"/g, 'href="http://' + window.location.host + '/org/' + this.curMenu.Id + '/' + this.curMenu.Key + '"')
            }else if(this.curMenu.Key === 'contact'){
				      curHtml =curHtml.split('<iframe')[0]
			      }
            this.htmlCont = curHtml
          }
        }
      })
    },
    getBtn: function (item) {
      if(this.$route.params.key !==item.Key){
        if (item.isList) {
          this.$router.push({name: 'news', params: {fkey: this.$route.params.fkey, key: item.Key}})
        } else {
          if(item.Key ==='Onlinepetition' || item.Key ==='Postbox'){
            window.open('mailto:JLFDJTXF@163.com')
          }else if (item.Key ==='Onlineschool'){
            window.open('http://e-learning.jinlinghotels.com:8092',"_blank")
          }else {
            this.$router.push({name: 'info', params: {fkey: this.$route.params.fkey, key: item.Key}})
          }
        }
      }
    }
  }
}
</script>
<style>
  .attachment img {
    height: 30px;
    width: 30px;
  }
  .html-wrap img{
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/info.vue